__turbopack_context__.v({
  "root": "DesktopComponent-module__7vmnQa__root",
  "top": "DesktopComponent-module__7vmnQa__top",
});
